/**
 * Provider routing, as the admin edits it: which email, SMS or payment
 * adapter handles a request, for whom, in what order.
 *
 * The adapters themselves live in `@zuruflex/providers`, which only the
 * API depends on. What is here is the shape of an edit and the checks the
 * API and the admin's form both apply, so the two cannot disagree about
 * what a valid route is.
 */
/** The kinds a `provider_routes` row can be for. Mirrors the Prisma enum. */
export const PROVIDER_ROUTE_KINDS = ['EMAIL', 'SMS', 'PAYMENT'];
/** The kinds a test message can be sent through. A test payment is not a thing. */
export const PROVIDER_TEST_KINDS = ['EMAIL', 'SMS'];
/** Lower runs first. Bounded so a typo cannot bury a route forever. */
export const PROVIDER_ROUTE_PRIORITY_MIN = 0;
export const PROVIDER_ROUTE_PRIORITY_MAX = 10_000;
export const PROVIDER_ROUTE_NOTES_MAX = 500;
/** ISO-3166 alpha-2, or "" for any country. Upper case only — that is how rows are stored. */
export function isRouteCountryCode(value) {
    return typeof value === 'string' && (value === '' || /^[A-Z]{2}$/.test(value));
}
/** ISO-4217, or "" for any currency. */
export function isRouteCurrency(value) {
    return typeof value === 'string' && (value === '' || /^[A-Z]{3}$/.test(value));
}
